import { render } from "./TvmScheduleServiceOptions.vue?vue&type=template&id=7c88f836&scoped=true"
import script from "./TvmScheduleServiceOptions.vue?vue&type=script&lang=js"
export * from "./TvmScheduleServiceOptions.vue?vue&type=script&lang=js"

import "./TvmScheduleServiceOptions.vue?vue&type=style&index=0&id=7c88f836&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c88f836"],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/TvmScheduleServiceOptions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c88f836"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c88f836', __exports__)) {
    api.reload('7c88f836', __exports__)
  }
  
  module.hot.accept("./TvmScheduleServiceOptions.vue?vue&type=template&id=7c88f836&scoped=true", () => {
    api.rerender('7c88f836', render)
  })

}


export default __exports__